<template>
    <confirm-dialog class="border"
        :title="title"
        :message="message"
        :showDialog="showDialog"
        @cancel="handleCancel"
        @confirm="handleConfirm"
        :no-icons="true"
    />
</template>

<script>
    import toaster from "../../common/toaster";
    import ConfirmDialog from "../../dialog/confirm-dialog.vue";
    import API from "../../../API";

    export default {
        name: 'delete-widget-dialog',
        components: {ConfirmDialog},
        data() {
            return {
                showDialog: false,
                multi: false,
                widgetName: '',
                widgetIDs: [],
            }
        },
        computed: {
            translations() {
                return {
                    title: this.multi ? Lang.langGet("Delete Widgets") : Lang.langGet("Delete Widget"),
                    failed: Lang.langGet('Failed to delete widget!'),
                    success: Lang.langGet("Widget was deleted successfully.")
                }
            },
            message() {
                if (this.multi) {
                    return Lang.langGet(
                        "Do you really want to delete all these widgets: :names?",
                        {names: this.widgetName}
                    );
                }
                return Lang.langGet('Do you really want to delete this widget?')
            },
            title() {
                if (this.multi) {
                    return this.translations.title;
                }
                return `${this.translations.title} - ${this.widgetName}`
            }
        },
        methods: {
            reset() {
                this.widgetName = '';
                this.widgetIDs = []
                this.multi = false;
            },
            show() {this.showDialog = true},
            hide() {this.showDialog = false},
            handleCancel() {this.hide()},
            async handleConfirm() {
                const url = '/administration/widget/delete';
                const api = new API(url);
                const response = await api.post({id: this.widgetIDs});

                if (response.errored) {
                    toaster.error(this.translations.failed);
                } else {
                    toaster.success(this.translations.success);
                    EaseEventBus.fire('updateWidgetlist');
                    this.hide();
                }
            },
        },
        mounted() {
            EaseEventBus.listen('deleteWidget', (widget) => {
                this.reset();
                this.show();

                this.widgetName = widget.name;
                this.widgetIDs.push(widget.id);

            });

            EaseEventBus.listen('multiDeleteWidget', (data) => {
                this.reset();
                this.show();

                this.widgetName = data.names;
                this.widgetIDs = data.ids;
                this.multi = (this.widgetIDs.length > 1);

                if(!this.multi) {
                    this.widgetName = this.widgetName[0];
                }
            });
        }
    }
</script>
